import * as Immutable from 'immutable';
import {
  TOGGLE_OPTION,
  ADD_OPTION,
  REMOVE_OPTION,
  CLEAR_OPTIONS,
  UPDATE_VOUCHER,
  UPDATE_BUSINESS,
  UPDATE_CART,
  UPDATE_CART_SUCCESS,
  UPDATE_CART_ERROR,
  FETCH_SUMMARY,
  FETCH_SUMMARY_SUCCESS,
  FETCH_SUMMARY_FAILURE,
  UPDATE_TRAVEL_TYPE,
} from '../actions/cart';
import type { State } from './index';
import type { OrderSummary, BusinessWorker } from '../types';

export interface CartState {
  options?: Immutable.Set<number>;
  summary?: OrderSummary;
  voucher?: string;
  travelType?: string;
  business?: string;
  worker?: BusinessWorker;
  error?: string;
  isCartReady?: boolean;
  isUpdatingVoucher?: boolean;
  isFetchingSummary: boolean;
  isUpdatingSummary: boolean;
}

const initialState = {
  isFetchingSummary: false,
  isUpdatingSummary: false,
};

export default (state: CartState = initialState, action: any) => {
  switch (action.type) {
    case TOGGLE_OPTION: {
      const toggle = (from: Immutable.Set<number>) =>
        from.has(action.option) ? from.delete(action.option) : from.add(action.option);

      const initial = () => {
        const fromSummary = state.summary
          ? state.summary.services
              .map(s => s.id)
              .filter(id => {
                if (action.previous) {
                  return id !== action.option;
                }

                return true;
              })
          : [];

        const result = Immutable.Set(fromSummary);

        if (action.previous) {
          return result;
        }

        return result.add(action.option);
      };

      const nextOptions = state.options ? toggle(state.options) : initial();

      return {
        ...state,
        options: nextOptions,
      };
    }
    case ADD_OPTION: {
      const { options } = state;
      if (options) {
        return {
          ...state,
          options: options.add(action.option),
        };
      }

      return state;
    }
    case REMOVE_OPTION: {
      const { options } = state;
      if (options) {
        return {
          ...state,
          options: options.delete(action.option),
        };
      }

      return state;
    }
    case CLEAR_OPTIONS:
      return {
        ...state,
        options: undefined,
      };
    case UPDATE_VOUCHER:
      return {
        ...state,
        isUpdatingVoucher: true,
        voucher: action.voucher,
      };
    case UPDATE_BUSINESS:
      return {
        ...state,
        business: action.business,
      };
    case UPDATE_TRAVEL_TYPE:
      return {
        ...state,
        travelType: action.travelType,
        business: action.business,
        worker: action.worker,
      };
    case FETCH_SUMMARY:
      return {
        ...state,
        isFetchingSummary: true,
      };
    case UPDATE_CART:
      return {
        ...state,
        isUpdatingSummary: true,
      };
    case FETCH_SUMMARY_SUCCESS:
    case UPDATE_CART_SUCCESS:
      return {
        ...state,
        summary: action.summary,
        error: undefined,
        isUpdatingVoucher: false,
        isFetchingSummary: false,
        isUpdatingSummary: false,
      };
    case UPDATE_CART_ERROR:
    case FETCH_SUMMARY_FAILURE:
      return {
        ...state,
        summary: undefined,
        error: action.error.displayMessage,
        isUpdatingVoucher: false,
        isFetchingSummary: false,
        isUpdatingSummary: false,
      };
    default:
      return state;
  }
};

export const getOptions = (state: State) => state.cart.options;
export const getSummary = (state: State) => state.cart.summary;
export const getVoucher = (state: State) => state.cart.voucher;
export const getIsUpdatingVoucher = (state: State) => state.cart.isUpdatingVoucher;
export const getBusiness = (state: State) => state.cart.business;
export const getTravelType = (state: State) => state.cart.travelType;
export const getWorker = (state: State) => state.cart.worker;
export const getError = (state: State) => state.cart.error;

export const isFetchingSummary = (state: State) => state.cart.isFetchingSummary;
export const isUpdatingSummary = (state: State) => state.cart.isUpdatingSummary;
